import { Moment } from "moment";

export const generateQueryParam = (queries: { key: string; value: any }[]) => {
  let params: string[] = [];

  (queries || []).forEach((query) => {
    if (query.value) {
      params.push(`${query.key}=${query.value}`);
    }
  });

  if (params.length) {
    return `?${params.join("&")}`;
  }

  return "";
};

export const formattedApiFriendlyDate = (date: Moment) => {
  return date.clone().format("YYYY-MM-DD");
};
